import { z } from "zod";


export const PgtoContratoFinanceiroSchema = z.object({
    idContratoFinanceiro: z.number().optional().nullable(),
    idIndiceReajuste: z.number().optional().nullable(),

    valorAParcelar: z.coerce.number().optional().nullable(),
    valorEntrada: z.coerce.number().optional().nullable(),

    percentualJuros: z.coerce.number().optional().nullable(),
    numeroParcelasEntrada: z.coerce.number().optional().nullable(),
    numeroParcelas: z.coerce.number().optional().nullable(),

    dataPrimeiroPgto: z.coerce.date({ invalid_type_error: "Data receber inválida." }).optional().nullable(),
    dataPgtoEntrada: z.coerce.date().optional().nullable(),
    intervaloDias: z.coerce.number().optional().nullable(),

    // SALVAR OBSERVAÇÃO
    idPgtoContratoFinanceiro: z.number().optional().nullable(),
    observacao: z.coerce.string().max(249, "Observação deve ter no máximo 249 caracteres.").optional().nullable(),

    //controle de cadastro
    parcelaSecundaria: z.coerce.boolean().optional().nullable(),

    // controle de campos
    projetarMeses: z.coerce.number().optional().default(0),
    dividirEntrada: z.coerce.number().optional().default(0),
    pagamentoAvista: z.coerce.number().optional().default(1),
    entrada: z.coerce.number().optional().default(1)
});

export type PgtoContratoFinanceiroForm = z.infer<typeof PgtoContratoFinanceiroSchema>;

export const defaultPgtoContratoFinanceiroForm: Partial<PgtoContratoFinanceiroForm> = {
    parcelaSecundaria: false,
    projetarMeses: 0,
    dividirEntrada: 0,
    pagamentoAvista: 1,
    entrada: 1,

}